import { ChangeBusinessDetails } from './ChangeBusinessDetails';

export class ChangeFacebookPixel extends ChangeBusinessDetails {
  type: string = 'ChangeFacebookPixel';
}
